import styles from "./Link.module.scss";

import { Link as RoutingLink } from "@/i18n/routing";
import { cn } from "@/utils/cn";

type Props = React.ComponentPropsWithoutRef<typeof RoutingLink>;
type BaseProps = Omit<Props, "prefix">;

interface LinkProps extends BaseProps {
  isNewTab?: boolean;
  children?: React.ReactNode;
}

const Link: React.FC<LinkProps> = ({
  children,
  isNewTab = false,
  scroll = false,
  className,
  ...rest
}) => (
  <RoutingLink
    className={cn(styles.base, className)}
    target={isNewTab ? "_blank" : undefined}
    rel={isNewTab ? "noreferrer" : undefined}
    scroll={scroll}
    {...rest}
  >
    {children}
  </RoutingLink>
);

export { Link };
export type { LinkProps };
